import { render, staticRenderFns } from "./InvestmentSolutions.vue?vue&type=template&id=1457d712&"
import script from "./InvestmentSolutions.vue?vue&type=script&lang=js&"
export * from "./InvestmentSolutions.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentSolutions.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports